import React from 'react';
import i18n from '@yandex-int/i18n';
import { WithAppStoreSnapshot, withAppStoreSnapshot } from 'client/context/appStoreSnapshotContext';
import { showAutoAppUi, showSmartScreenUi } from 'client/utils';
import { InstallableAppCardList } from '../InstallableAppCardList/InstallableAppCardList';
import { IndexLayout } from '../Layout/Layout';
import { Channel } from 'client/model/skill';
import { LayoutNavLink } from '../LayoutNavLink/LayoutNavLink';
import { routes } from 'client/lib/routes';
import { TvIcon } from '../icons/TvIcon';
import { SmartScreenIcon } from '../icons/SmartScreenIcon';
import { AliceIcon } from '../icons/AliceIcon';
import * as keyset from 'i18n/SkillsIndex';

import styles from './InstallableAppsIndex.module.scss';

interface InstallableAppsIndexProps {
    channel: Channel;
    onCreateAppClick: (channel: Channel) => void;
}

const t = i18n(keyset);

const InstallableAppsIndex = ({ channel, onCreateAppClick }: InstallableAppsIndexProps & WithAppStoreSnapshot) => {
    return (
        <IndexLayout>
            <article className={styles.installableAppsIndex__container}>
                <nav className={styles.navLinks}>
                    <div className={styles.navLinks__contentBlock}>
                        {/*
                        <LayoutNavLink
                            // TODO: waiting "all_available" API endpoint
                            to={routes.app.root}
                            icon={<Shield />}
                            isActive={false}
                            label={'_All available'}
                        />
                        <LayoutNavLink to={routes.app.root} isActive={true} label={'_Mine'} />
                        */}
                    </div>
                    <div className={styles.navLinks__contentBlock}>
                        <LayoutNavLink
                            to={routes.app.installableApps(Channel.TvApp)}
                            icon={<TvIcon />}
                            isActive={channel === Channel.TvApp}
                            label={t('tv')}
                        />
                        {showAutoAppUi() && (
                            <LayoutNavLink
                                to={routes.app.installableApps(Channel.AutoApp)}
                                icon={<SmartScreenIcon />}
                                isActive={channel === Channel.AutoApp}
                                label={t('auto-app')}
                            />
                        )}
                        {showSmartScreenUi() && (
                            <LayoutNavLink
                                to={routes.app.installableApps(Channel.SmartScreenApp)}
                                icon={<SmartScreenIcon />}
                                isActive={channel === Channel.SmartScreenApp}
                                label={t('smart-screen')}
                            />
                        )}
                        <LayoutNavLink
                            to={routes.app.skills}
                            icon={<AliceIcon />}
                            isActive={channel === Channel.AliceSkill}
                            label={t('alice-skills')}
                        />
                        {/* <LayoutNavLink
                            // Temporary disabled
                            external
                            to={routes.external.aliceStandalone}
                            icon={<SparksIcon />}
                            label={'GPT'}
                        /> */}
                    </div>
                </nav>
                <InstallableAppCardList onAppCreate={onCreateAppClick} channel={channel} />
            </article>
        </IndexLayout>
    );
};

export default withAppStoreSnapshot(InstallableAppsIndex);
